import { useEffect } from 'react';
import { getLenis } from './useLenis';

let locks = 0;
let originalOverflow = '';
let originalPriority = '';
let pausedLenis: ReturnType<typeof getLenis> = null;

export function acquireBodyScrollLock() {
  if (locks++ === 0) {
    originalOverflow = document.body.style.getPropertyValue('overflow');
    originalPriority = document.body.style.getPropertyPriority('overflow');
    document.body.style.setProperty('overflow', 'hidden');
    const lenis = getLenis();
    pausedLenis = lenis && !lenis.isStopped ? lenis : null;
    pausedLenis?.stop();
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--locks !== 0) return;
    if (originalOverflow) document.body.style.setProperty('overflow', originalOverflow, originalPriority);
    else document.body.style.removeProperty('overflow');
    if (pausedLenis === getLenis()) pausedLenis?.start();
    pausedLenis = null;
  };
}

export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (locked) return acquireBodyScrollLock();
  }, [locked]);
}
